import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ENV } from '../core-ng/injection-token';
import { ListType } from '../enum/list-type.enum';

export interface surveyList {
  id?: string;
  name: string;
  survey_id: number;
  list_type: ListType;
}

@Injectable({
  providedIn: 'root',
})
export class SurveyListService {
  private http = inject(HttpClient);
  environment = inject(ENV);

  getList(survey_id: number): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.environment.consoleApi}/survey-builder/get-lists/${survey_id}`,
    );
  }
  createList(payload: {
    name: string;
    list_type: ListType;
    survey_id: number;
  }): Observable<any> {
    return this.http.post(
      `${this.environment.consoleApi}/survey-builder/create-list`,
      payload,
    );
  }
}
